import type {PlayerStoreApi} from '@common/player/state/player-state';

const RESUME_WINDOW_MS = 4000;

let resumeAfterOverlayOpen = false;
let resumeMarkedAt = 0;
let playerGetState: PlayerStoreApi['getState'] | null = null;

export function registerPlayerGetState(getState: PlayerStoreApi['getState']) {
  playerGetState = getState;
}

export function markResumePlaybackAfterOverlayOpen() {
  resumeAfterOverlayOpen = true;
  resumeMarkedAt = Date.now();
}

export function shouldResumePlaybackAfterOverlayOpen() {
  return (
    resumeAfterOverlayOpen && Date.now() - resumeMarkedAt < RESUME_WINDOW_MS
  );
}

export function clearResumePlaybackAfterOverlayOpen() {
  resumeAfterOverlayOpen = false;
}

/** Re-issue play() after overlay layout changes (YouTube pauses on reparent/resize). */
export function scheduleResumePlaybackIfPending(
  getState: PlayerStoreApi['getState'] = playerGetState!,
) {
  if (!getState || !shouldResumePlaybackAfterOverlayOpen()) {
    return;
  }

  const attempt = () => {
    if (!shouldResumePlaybackAfterOverlayOpen()) {
      return;
    }
    const {providerApi, isPlaying} = getState();
    if (isPlaying) {
      clearResumePlaybackAfterOverlayOpen();
      return;
    }
    providerApi?.play();
  };

  attempt();
  requestAnimationFrame(() => {
    attempt();
    requestAnimationFrame(attempt);
  });

  for (const ms of [50, 120, 250, 500, 900, 1500, 2500]) {
    setTimeout(attempt, ms);
  }

  setTimeout(() => {
    if (getState().isPlaying) {
      clearResumePlaybackAfterOverlayOpen();
    }
  }, RESUME_WINDOW_MS);
}
